/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AreaPost,
  HistoricalTrack,
  JobId,
  SelectShip,
  Ship,
  ShipHistoricalPortPost200Response,
  ShipHistoricalPost,
  ShipHistoricalTrackPost202Response,
  ShipId,
  ShipInfoBulkRequest,
  ShipInfoBulkResponse,
  ShipInfoMmsiGet200Response,
  ShipListResponse,
  ShipPositionMmsiGet200Response,
  ShipPositionPost200Response,
  ShipPositionPostRequest,
  ShipRegisterGet200Response,
  ShipSearchQuerystringGet200Response,
  ShipSelectGet200Response,
  StandardResponse,
  TripHistorical,
} from '../models';
import {
    AreaPostFromJSON,
    AreaPostToJSON,
    HistoricalTrackFromJSON,
    HistoricalTrackToJSON,
    JobIdFromJSON,
    JobIdToJSON,
    SelectShipFromJSON,
    SelectShipToJSON,
    ShipFromJSON,
    ShipToJSON,
    ShipHistoricalPortPost200ResponseFromJSON,
    ShipHistoricalPortPost200ResponseToJSON,
    ShipHistoricalPostFromJSON,
    ShipHistoricalPostToJSON,
    ShipHistoricalTrackPost202ResponseFromJSON,
    ShipHistoricalTrackPost202ResponseToJSON,
    ShipIdFromJSON,
    ShipIdToJSON,
    ShipInfoBulkRequestFromJSON,
    ShipInfoBulkRequestToJSON,
    ShipInfoBulkResponseFromJSON,
    ShipInfoBulkResponseToJSON,
    ShipInfoMmsiGet200ResponseFromJSON,
    ShipInfoMmsiGet200ResponseToJSON,
    ShipListResponseFromJSON,
    ShipListResponseToJSON,
    ShipPositionMmsiGet200ResponseFromJSON,
    ShipPositionMmsiGet200ResponseToJSON,
    ShipPositionPost200ResponseFromJSON,
    ShipPositionPost200ResponseToJSON,
    ShipPositionPostRequestFromJSON,
    ShipPositionPostRequestToJSON,
    ShipRegisterGet200ResponseFromJSON,
    ShipRegisterGet200ResponseToJSON,
    ShipSearchQuerystringGet200ResponseFromJSON,
    ShipSearchQuerystringGet200ResponseToJSON,
    ShipSelectGet200ResponseFromJSON,
    ShipSelectGet200ResponseToJSON,
    StandardResponseFromJSON,
    StandardResponseToJSON,
    TripHistoricalFromJSON,
    TripHistoricalToJSON,
} from '../models';

export interface GetBulkShipInfoRequest {
    json: ShipInfoBulkRequest;
}

export interface ShipAreaIdGetRequest {
    id: number;
}

export interface ShipAreaPostRequest {
    json: AreaPost;
}

export interface ShipHistoricalPortPostRequest {
    json: ShipHistoricalPost;
}

export interface ShipHistoricalTrackIdGetRequest {
    id: string;
}

export interface ShipHistoricalTrackPostRequest {
    json: ShipHistoricalPost;
}

export interface ShipHistoricalTripPostRequest {
    json: ShipHistoricalPost;
}

export interface ShipInfoMmsiGetRequest {
    mmsi: number;
}

export interface ShipPositionMmsiGetRequest {
    mmsi: number;
}

export interface ShipPositionPostOperationRequest {
    shipPositionPostRequest: ShipPositionPostRequest;
}

export interface ShipRegisterMmsiGetRequest {
    mmsi: number;
}

export interface ShipRegisterMmsiPutRequest {
    mmsi: number;
    json: Ship;
}

export interface ShipRegisterPostRequest {
    json: Ship;
}

export interface ShipSearchQuerystringGetRequest {
    querystring: string;
}

export interface ShipSelectOwnerGetRequest {
    owner: string;
}

export interface ShipSelectPostRequest {
    json: SelectShip;
}

/**
 * 
 */
export class ShipApi extends runtime.BaseAPI {

    /**
     * Retrieve static ship information for multiple ships by providing a list of MMSIs, IMOs, or a shiplist name. This endpoint allows bulk queries for ship information. The response format for each ship matches the output of the single ship endpoint /ship/info/{mmsi}.
     * Get static ship information for multiple ships
     */
    async getBulkShipInfoRaw(requestParameters: GetBulkShipInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipInfoBulkResponse>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling getBulkShipInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShipInfoBulkRequestToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipInfoBulkResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve static ship information for multiple ships by providing a list of MMSIs, IMOs, or a shiplist name. This endpoint allows bulk queries for ship information. The response format for each ship matches the output of the single ship endpoint /ship/info/{mmsi}.
     * Get static ship information for multiple ships
     */
    async getBulkShipInfo(requestParameters: GetBulkShipInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipInfoBulkResponse> {
        const response = await this.getBulkShipInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Once the job has been completed (or aborted) and result given back the job is deleted. The operation will timeout if not completed in two minutes.
     * Query / poll result by identifier
     */
    async shipAreaIdGetRaw(requestParameters: ShipAreaIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipListResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shipAreaIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/area/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipListResponseFromJSON(jsonValue));
    }

    /**
     * Once the job has been completed (or aborted) and result given back the job is deleted. The operation will timeout if not completed in two minutes.
     * Query / poll result by identifier
     */
    async shipAreaIdGet(requestParameters: ShipAreaIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipListResponse> {
        const response = await this.shipAreaIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return a list of ships in given area at a given point in time.
     * Return a list of ships in given area at a given point in time.
     */
    async shipAreaPostRaw(requestParameters: ShipAreaPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobId>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipAreaPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/area`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AreaPostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobIdFromJSON(jsonValue));
    }

    /**
     * Return a list of ships in given area at a given point in time.
     * Return a list of ships in given area at a given point in time.
     */
    async shipAreaPost(requestParameters: ShipAreaPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobId> {
        const response = await this.shipAreaPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of last visited ports for the given ship.
     * Get a list of last visited ports for the given ship.
     */
    async shipHistoricalPortPostRaw(requestParameters: ShipHistoricalPortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipHistoricalPortPost200Response>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipHistoricalPortPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/historical/port`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShipHistoricalPostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipHistoricalPortPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a list of last visited ports for the given ship.
     * Get a list of last visited ports for the given ship.
     */
    async shipHistoricalPortPost(requestParameters: ShipHistoricalPortPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipHistoricalPortPost200Response> {
        const response = await this.shipHistoricalPortPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a historical track for the given ship for the given period between begin and end. Resolution of the track indicates the interval between samples returned. The time period is described by the input to path /ship/historical/track POST.
     * Get historical track for ship
     */
    async shipHistoricalTrackIdGetRaw(requestParameters: ShipHistoricalTrackIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoricalTrack>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shipHistoricalTrackIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/historical/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HistoricalTrackFromJSON(jsonValue));
    }

    /**
     * Get a historical track for the given ship for the given period between begin and end. Resolution of the track indicates the interval between samples returned. The time period is described by the input to path /ship/historical/track POST.
     * Get historical track for ship
     */
    async shipHistoricalTrackIdGet(requestParameters: ShipHistoricalTrackIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoricalTrack> {
        const response = await this.shipHistoricalTrackIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a historical track for the given ship for the given period between begin and end. Resolution of the track indicates the interval between samples returned.
     * Get a historical track for the given ship for the given period.
     */
    async shipHistoricalTrackPostRaw(requestParameters: ShipHistoricalTrackPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipHistoricalTrackPost202Response>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipHistoricalTrackPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/historical/track`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShipHistoricalPostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipHistoricalTrackPost202ResponseFromJSON(jsonValue));
    }

    /**
     * Get a historical track for the given ship for the given period between begin and end. Resolution of the track indicates the interval between samples returned.
     * Get a historical track for the given ship for the given period.
     */
    async shipHistoricalTrackPost(requestParameters: ShipHistoricalTrackPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipHistoricalTrackPost202Response> {
        const response = await this.shipHistoricalTrackPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of last trips for the given ship.
     * Get a list of last trips for the given ship.
     */
    async shipHistoricalTripPostRaw(requestParameters: ShipHistoricalTripPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TripHistorical>>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipHistoricalTripPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/historical/trip`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShipHistoricalPostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TripHistoricalFromJSON));
    }

    /**
     * Get a list of last trips for the given ship.
     * Get a list of last trips for the given ship.
     */
    async shipHistoricalTripPost(requestParameters: ShipHistoricalTripPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TripHistorical>> {
        const response = await this.shipHistoricalTripPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the most current static ship information for a specific ship
     */
    async shipInfoMmsiGetRaw(requestParameters: ShipInfoMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipInfoMmsiGet200Response>> {
        if (requestParameters.mmsi === null || requestParameters.mmsi === undefined) {
            throw new runtime.RequiredError('mmsi','Required parameter requestParameters.mmsi was null or undefined when calling shipInfoMmsiGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/info/{mmsi}`.replace(`{${"mmsi"}}`, encodeURIComponent(String(requestParameters.mmsi))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipInfoMmsiGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the most current static ship information for a specific ship
     */
    async shipInfoMmsiGet(requestParameters: ShipInfoMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipInfoMmsiGet200Response> {
        const response = await this.shipInfoMmsiGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the most current position for a specific ship
     */
    async shipPositionMmsiGetRaw(requestParameters: ShipPositionMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipPositionMmsiGet200Response>> {
        if (requestParameters.mmsi === null || requestParameters.mmsi === undefined) {
            throw new runtime.RequiredError('mmsi','Required parameter requestParameters.mmsi was null or undefined when calling shipPositionMmsiGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/position/{mmsi}`.replace(`{${"mmsi"}}`, encodeURIComponent(String(requestParameters.mmsi))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipPositionMmsiGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the most current position for a specific ship
     */
    async shipPositionMmsiGet(requestParameters: ShipPositionMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipPositionMmsiGet200Response> {
        const response = await this.shipPositionMmsiGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the most current position for a specific list of ships
     */
    async shipPositionPostRaw(requestParameters: ShipPositionPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipPositionPost200Response>> {
        if (requestParameters.shipPositionPostRequest === null || requestParameters.shipPositionPostRequest === undefined) {
            throw new runtime.RequiredError('shipPositionPostRequest','Required parameter requestParameters.shipPositionPostRequest was null or undefined when calling shipPositionPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/position/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShipPositionPostRequestToJSON(requestParameters.shipPositionPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipPositionPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the most current position for a specific list of ships
     */
    async shipPositionPost(requestParameters: ShipPositionPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipPositionPost200Response> {
        const response = await this.shipPositionPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get static ship information for all ships from the ship register
     */
    async shipRegisterGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipRegisterGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/register`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipRegisterGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get static ship information for all ships from the ship register
     */
    async shipRegisterGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipRegisterGet200Response> {
        const response = await this.shipRegisterGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get static ship information for a specific ship from the ship register
     */
    async shipRegisterMmsiGetRaw(requestParameters: ShipRegisterMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipRegisterGet200Response>> {
        if (requestParameters.mmsi === null || requestParameters.mmsi === undefined) {
            throw new runtime.RequiredError('mmsi','Required parameter requestParameters.mmsi was null or undefined when calling shipRegisterMmsiGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/register/{mmsi}`.replace(`{${"mmsi"}}`, encodeURIComponent(String(requestParameters.mmsi))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipRegisterGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get static ship information for a specific ship from the ship register
     */
    async shipRegisterMmsiGet(requestParameters: ShipRegisterMmsiGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipRegisterGet200Response> {
        const response = await this.shipRegisterMmsiGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a new ship in the ship register.
     */
    async shipRegisterMmsiPutRaw(requestParameters: ShipRegisterMmsiPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShipId>>> {
        if (requestParameters.mmsi === null || requestParameters.mmsi === undefined) {
            throw new runtime.RequiredError('mmsi','Required parameter requestParameters.mmsi was null or undefined when calling shipRegisterMmsiPut.');
        }

        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipRegisterMmsiPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/register/{mmsi}`.replace(`{${"mmsi"}}`, encodeURIComponent(String(requestParameters.mmsi))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ShipToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShipIdFromJSON));
    }

    /**
     * Update a new ship in the ship register.
     */
    async shipRegisterMmsiPut(requestParameters: ShipRegisterMmsiPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShipId>> {
        const response = await this.shipRegisterMmsiPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a new ship to the ship register.
     * Add a new ship to the ship register.
     */
    async shipRegisterPostRaw(requestParameters: ShipRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShipId>>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipRegisterPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShipToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ShipIdFromJSON));
    }

    /**
     * Add a new ship to the ship register.
     * Add a new ship to the ship register.
     */
    async shipRegisterPost(requestParameters: ShipRegisterPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShipId>> {
        const response = await this.shipRegisterPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the most current static ship information for ship(s) matching a query string
     */
    async shipSearchQuerystringGetRaw(requestParameters: ShipSearchQuerystringGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipSearchQuerystringGet200Response>> {
        if (requestParameters.querystring === null || requestParameters.querystring === undefined) {
            throw new runtime.RequiredError('querystring','Required parameter requestParameters.querystring was null or undefined when calling shipSearchQuerystringGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/search/{querystring}`.replace(`{${"querystring"}}`, encodeURIComponent(String(requestParameters.querystring))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipSearchQuerystringGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the most current static ship information for ship(s) matching a query string
     */
    async shipSearchQuerystringGet(requestParameters: ShipSearchQuerystringGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipSearchQuerystringGet200Response> {
        const response = await this.shipSearchQuerystringGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get selected ships for pan/zoom for this calling user.
     */
    async shipSelectGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipSelectGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/select`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipSelectGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get selected ships for pan/zoom for this calling user.
     */
    async shipSelectGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipSelectGet200Response> {
        const response = await this.shipSelectGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get selected ships for pan/zoom for this calling user for the supplied owner.
     */
    async shipSelectOwnerGetRaw(requestParameters: ShipSelectOwnerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShipSelectGet200Response>> {
        if (requestParameters.owner === null || requestParameters.owner === undefined) {
            throw new runtime.RequiredError('owner','Required parameter requestParameters.owner was null or undefined when calling shipSelectOwnerGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/select/{owner}`.replace(`{${"owner"}}`, encodeURIComponent(String(requestParameters.owner))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShipSelectGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Get selected ships for pan/zoom for this calling user for the supplied owner.
     */
    async shipSelectOwnerGet(requestParameters: ShipSelectOwnerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShipSelectGet200Response> {
        const response = await this.shipSelectOwnerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Select a ship for display pan/zoom for a user in aisWeb.
     */
    async shipSelectPostRaw(requestParameters: ShipSelectPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipSelectPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/select`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectShipToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Select a ship for display pan/zoom for a user in aisWeb.
     */
    async shipSelectPost(requestParameters: ShipSelectPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.shipSelectPostRaw(requestParameters, initOverrides);
    }

}
